function formatAnswerFilter() {
    'ngInject';

    return function (answer) {
        if (typeof answer === 'boolean') {
            answer = answer === true ? 'Yes' : 'No';
        } else if (moment(answer, 'YYYY-MM-DD', true).isValid()) {
            answer = moment(answer).format('D MMMM YYYY');
        }
        return answer;
    };
}

angular
    .module('BB')
    .filter('format_answer', formatAnswerFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/format_answer.filter.js